<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <div class="sub-title">
          门诊日志查询
        </div>
        <div>
          <el-date-picker v-model="dateRange" type="datetimerange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="dateRangeChanged">
          </el-date-picker>
          <el-input v-model="condition.keyword" placeholder="处方号/请求路径" size="small" v-on:keyup.enter.native="queryEntities(1)" class="condition-wide" clearable>
            <el-button type="info" :loading="searchLoading" slot="append" icon="el-icon-search" @click="queryEntities(1)">查询</el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>
    <el-main style="padding: 0px">
      <el-table v-loading="searchLoading" @filter-change="filterChanged" height="100%" :data="entities.items" @sort-change="handleSortChange" class="main-table">
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-view" title="查看详情" plain circle size="mini" @click="view(scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="处方号/请求路径" prop="rpNo" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column sortable="custom" label="类型" prop="type" min-width="100" :filters="typeData" :filter-multiple="false" column-key="type">
          <template slot-scope="{row}">
            <el-tag size="small" effect="plain">{{getTypeName(row.type)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createDate" min-width="100" />
        <el-table-column label="请求参数" prop="request" min-width="150" show-overflow-tooltip />
        <el-table-column label="返回参数" prop="response" min-width="150" show-overflow-tooltip />
      </el-table>
    </el-main>
    <pagination :entities="entities" @queryEntities="queryEntities" :condition="condition" />
    <log-view v-model="entity" :visible.sync="showView" />
  </el-container>
</template>

<script>
import api from "./api";
export default {
  components: {
    pagination: () => import("@/components/_com/pagination"),
    "log-view": () => import("./view"),
  },
  computed: {
    typeData () {
      return [{ text: '配送下单', value: 1 }, { text: '自动审方下单', value: 2 }, { text: '排队叫号接口', value: 3 }]
    }
  },
  data () {
    return {
      showView: false,
      dateRange: [],
      searchLoading: false,
      entity: {},
      condition: {
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 10
      },
      entities: {
        items: []
      }
    };
  },
  created () {
    this.dateRange = [
      this.$utils.fmtDate(this.$utils.serverTime) + ' 00:00:00',
      this.$utils.fmtDate(this.$utils.serverTime) + ' 23:59:59'
    ]
    this.condition.startDate = this.dateRange[0]
    this.condition.endDate = this.dateRange[1]
    this.queryEntities();
  },
  mounted () { },
  methods: {
    getTypeName (type) {
      if (type == 1) return '配送下单';
      if (type == 2) return '自动审方下单';
      if (type == 3) return '排队叫号接口';
    },
    handleSortChange ({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.queryEntities();
    },
    filterChanged (options) {
      Object.assign(this.condition, options);
      this.queryEntities();
    },
    queryEntities () {
      this.searchLoading = true;
      api.queryOpLog(this.condition).then(res => {
        this.entities = res;
        console.log(this.entities);
      }).catch(err => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.searchLoading = false;
      });
    },
    dateRangeChanged (range) {
      if (range && range.length > 0) {
        this.condition.startDate = range[0];
      } else {
        this.condition.startDate = null
      }
      if (range && range.length > 1) {
        this.condition.endDate = range[1];
      } else {
        this.condition.endDate = null
      }
      this.queryEntities()
    },
    view (row) {
      this.entity = row
      this.showView = true
    }
  }
};
</script>

<style scoped>
.condition-wide {
  width: 15rem;
  margin-left: 0.5rem;
  color: #a5a1a1;
}
</style>
